import React, { FC, useState } from "react";
import { Feature, features as defaultFeatures } from "./constant";

interface Props {
  features?: Feature[];
  sectionTitle?: string;
}

export const FeatureSection: FC<Props> = ({
  sectionTitle,
  features = defaultFeatures,
}) => {
  const [active, setActive] = useState(features[0]);

  return (
    <section className="bg-gradient-to-r from-[#000428] to-[#004E92] text-ashShade-17">
      <div className="py-16 md:py-24 px-4 md:px-16">
        <div className="flex flex-col  gap-6 md:gap-x-16 referral-container">
          <p className="text-3xl md:text-5xl font-SatoshiBold text-center">
            {sectionTitle ?? (
              <>
                Build with Confidence. <br /> Invest with Clarity
              </>
            )}
          </p>
          <div className="-mx-4">
            <div className="flex gap-4 lg:gap-6 overflow-x-auto no-scrollbar flex-nowrap lg:justify-center px-4 md:px-16">
              {features.map((feature) => (
                <button
                  key={feature.name}
                  className={`whitespace-nowrap text-sm lg:text-base transition font-SatoshiMedium ${
                    active.name === feature.name
                      ? "bg-blueShades-7 py-1 px-3 rounded-full text-blueShades-4"
                      : "text-ashShade-17"
                  }`}
                  onClick={() => setActive(feature)}
                >
                  {feature.name}
                </button>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-10 md:gap-14 bg-ashShade-17 rounded-xl shadow-lg w-full">
            <div className="flex flex-col gap-6 px-11 pt-[60px] lg:w-[600px] 2xl:w-[563px]">
              <p className="text-3xl lg:text-4xl text-blueShades-4 font-satoshi font-semibold">
                {active.name}
              </p>
              <p className="text-lg text-ashShade-16 font-SatoshiMedium">
                {active.description}
              </p>
            </div>
            <img
              src={active.image}
              alt={active.name}
              className="w-full h-64 object-cover rounded-bl-xl rounded-br-xl md:rounded-br-none md:h-auto md:pr-10"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
